import BFFResponse from '~/services/bff/BFFResponse';

const generateTraceId = (prefix = 'st') => `${prefix}-${Date.now()}-${Math.floor(Math.random() * 90000) + 10000}`; // prefix-timestampInMili-fiveRandomNumbers

/* eslint-disable no-underscore-dangle */
export default defineNuxtPlugin(() => {
  const fallbackOrigin = useRequestURL().origin;
  const { $domain, $config } = useNuxtApp();

  const $bffApiFetch = $fetch.create({
    credentials: 'include',
    baseURL: useRequestURL().origin,
    onRequest({ options }) {
      const { baseURL: currentBaseURL = fallbackOrigin } = options;
      if (!currentBaseURL) {
        return;
      }

      const {
        baseURL = currentBaseURL,
        requestTimeout = options.timeout,
        headers,
      } = requestConfiguration(currentBaseURL) || {};

      options.headers ??= new Headers();
      Object.entries(headers).forEach(([key, value]) => options.headers?.set(key, value));

      options.baseURL = baseURL;
      options.timeout = requestTimeout;
    },
    onRequestError(context) {
      if (import.meta.server) {
        console.log('onRequestError', context.response?._data.data);
      }
      if (!context.error) {
        return;
      }
    },
    onResponse(context) {
      if (!context.response) {
        return;
      }
      const response: BFFResponse = new BFFResponse(context.response._data);
      context.response._data = response.get();
    },
    onResponseError(context) {
      if (import.meta.server) {
        console.log('onResponseError:', {
          data: context.response?._data.data,
          url: context.options.baseURL,
          request: context.request,
          headers: context.options.headers,
        });
      }
      throw new BFFResponse(null, { ...context.response?._data.data, status: context.response?.status }).get()?.errors;
    },
    timeout: 10000,
  });

  const basicAuth = () => {
    if (!import.meta.server && $config.public.basicAuthCredentials) {
      return {
        Authorization: `Basic ${$config.public.basicAuthCredentials}`,
      };
    }
    return null;
  };

  const requestConfiguration = (originDomain: string) => {
    const basicAuthUrl = basicAuth() ?? {};

    const headers = {
      'x-trace-id': generateTraceId(),
      ...(import.meta.server
        ? {
            'x-client': 'server',
            'Origin': originDomain,
          }
        : {
            ...(basicAuthUrl),
          }),
    } as HeadersInit;

    const { domainSsr, domainCsr, apiVersion, apiBase, defaultTimeout } = $domain.int.bff;
    const baseURL = (import.meta.server ? domainSsr : domainCsr) ?? originDomain;

    return {
      baseURL: `${baseURL}${apiBase}${apiVersion}`,
      requestTimeout: defaultTimeout,
      headers,
    };
  };

  return {
    provide: {
      bffApiFetch: $bffApiFetch,
    },
  };
});
